<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100 mx-auto">
      <simple-wizard @tab-change="tabchange">
        <template slot="header">
          <h3 class="title">新增任务</h3>
        </template>
        <wizard-tab :before-change="() => validateStep('step1')">
          <template slot="label">任务信息</template>
          <new-task-info ref="step1" @on-validated="onStepValidated" @handleChoose="handleChoose"
            @handleSceneChoose="handleSceneChoose"></new-task-info>
        </wizard-tab>
        <wizard-tab :before-change="() => validateStep('step2')">
          <template slot="label">任务流程</template>
          <new-task-flow ref="step2" :validateStep="validateStep" @on-validated="onStepValidated" :treeData="treeData">
          </new-task-flow>
        </wizard-tab>
      </simple-wizard>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { queryTreeData } from "@/api/device";
import NewTaskInfo from "../Task/NewTaskInfo.vue";
import NewTaskFlow from "./TaskFlow/NewTaskFlow.vue";
import Swal from "sweetalert2";
import { SimpleWizard, WizardTab } from "@/components";
import { addTask, updateTask, getTaskInfo } from "@/api/task/task";

export default {
  data() {
    return {
      wizardModel: {},
      taskInfo: {},
      treeData: [],
      sceneTreeData: []
    };
  },

  provide() {
    return {
      taskInfo: this,
    };
  },

  components: {
    NewTaskInfo,
    NewTaskFlow,
    SimpleWizard,
    WizardTab,
  },
  mounted() {
    if (this.$route.query._id) {
      getTaskInfo(this.$route.query._id).then(res => {
        this.$store.commit("global/SET_TASKINFO", res.data);
        // this.taskInfo = res.data
        this.$refs['step1'].init()
      })
    }
  },
  methods: {
    handleChoose(sceneId) {
      queryTreeData({
        sceneId,
      }).then((res) => {
        if (res.data) {
          this.treeData = res.data.treeArr;
        }
      });
    },
    handleSceneChoose(sceneId) {
      queryTreeData({
        sceneId,
      }).then((res) => {
        if (res.data) {
          this.sceneTreeData = res.data.treeArr;
        }
      });
    },
    tabchange(pre, next) {
      const nextRefStr = next.$slots.default[0].data.ref;
      const preRefStr = pre.$slots.default[0].data.ref;

      if (preRefStr === "step1") {
        Object.assign(this.taskInfo, this.$refs["step1"].form);
      } else{
        //如果当前处于编辑器状态，切换tab时候保存编辑器数据
        this.cacheData('step2')
      }

      this.$nextTick(() => {
        if (nextRefStr === "step1") {
          this.$refs["step1"].initForm(this.taskInfo);
        } else if (this.taskInfo._id||this.taskInfo.flowJsonData) {
          this.$refs["step2"].initFlow(this.taskInfo);
        }
      });
    },
    validateStep(ref,noBack) {
      let treeNodeMap = this.treeData.reduce((pre, next) => {
        pre[next.id] = next;
        return pre;
      }, {});

      treeNodeMap = this.sceneTreeData.reduce((pre, next) => {
        pre[next.id] = next;
        return pre;
      }, treeNodeMap);


      const getAliasName = (treeNodeId, treeNodeMap, nodeNameArr = []) => {
        const node = treeNodeMap[treeNodeId];
        if (!treeNodeId || !treeNodeMap || !node) {
          return "";
        }
        nodeNameArr.push(node ? node.name : "");
        if (node.level === 1) {
          return nodeNameArr.reverse().join("/");
        }
        return getAliasName(node.pid, treeNodeMap, nodeNameArr);
      };

      if (ref === "step2") {
        this.cacheData(ref,noBack)
        const handleFunc = this.taskInfo._id ? updateTask : addTask;
        handleFunc(this.taskInfo).then((result) => {
          if (result.code == 200) {
            this.$notify({
              timeout: 1500,
              message: "操作成功！",
              icon: "add_alert",
              horizontalAlign: "center",
              verticalAlign: "bottom",
              type: "success",
            });
            if(!noBack){
              this.back();
            }
            //操作成功清空缓存数据
            this.$store.commit("global/SET_TASKINFO", '');
          } else {
            this.$notify({
              timeout: 1500,
              message: result.message,
              horizontalAlign: "center",
              verticalAlign: "bottom",
              type: "warning",
            });
          }
        });
      }
      return this.$refs[ref].validate();
    },
    cacheData(ref,noBack){
      //保存编辑器数据
      const flowJsonData = this.$refs[ref].getTaskJson();
        const flowMapData = this.$refs[ref].flowMapData;
        const flowTriggerMap = this.$refs[ref].flowTriggerMap;
        this.taskInfo.flowMapData = flowMapData;
        this.taskInfo.flowJsonData = flowJsonData;
        this.taskInfo.flowTriggerMap = flowTriggerMap;
        const trees = this.$refs[ref].getTaskTree()
        if (trees.length > 1) {
          this.$Msg('只能有一个根结点', 'warning')
          return;
        }
        this.taskInfo.subTaskGraph = this.$refs[ref].getTaskTree()

        this.taskInfo.subTaskList = flowJsonData.cells
          .filter((item) => item.shape === "dag-node")
          .map((item) => {
            const { data } = item;
            return {
              subTaskGuid: data.id,
              subTaskName: data.label,
              subTaskType: data.type,
              describe: data.description ?? '',
              trigger: flowTriggerMap[data.id],
              stepList: flowMapData[data.id]
                ? flowMapData[data.id].map((stepItem) => {
                  return {
                    alias: getAliasName(stepItem.structId, treeNodeMap),
                    methodName: stepItem.templateName,
                    methodParams: [stepItem.defaultValue],
                    tnf_type: stepItem.type,
                    actor_template_id: stepItem.templateId,
                    runTime: stepItem.stepTime,
                    actionFormData: stepItem
                  };
                })
                : [],
            };
          });
      this.$store.commit("global/SET_TASKINFO", this.taskInfo);
    },
    onStepValidated(validated, model) {
      this.wizardModel = { ...this.wizardModel, ...model };
    },
    back() {
      this.$router.push({ path: "./task" });
    },
    wizardComplete() {
      Swal.fire({
        title: "Good job!",
        text: "You clicked the finish button!",
        type: "success",
        confirmButtonClass: "md-button md-success",
        buttonsStyling: false,
      });
    },
  },
};
</script>
